// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"284":"9ce5e9cd","506":"b96f4d4a","594":"cda0f325","678":"b4c9ae6f","944":"3944978a"}[chunkId] + ".css";
};